import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Input,
  Select,
  Skeleton,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useDeferredValue, useState } from "react"

import PlatformShell from "../../components/PlatformAdmin/PlatformShell"
import { listPlatformAuditLogs } from "../../client/platform"
import { isPlatformLoggedIn, isTenantSubdomainHost } from "../../utils/platformAuth"

export const Route = createFileRoute("/platform/audit-logs")({
  component: PlatformAuditLogsPage,
  beforeLoad: async () => {
    if (isTenantSubdomainHost()) {
      throw redirect({ to: "/login" })
    }
    if (!isPlatformLoggedIn()) {
      throw redirect({ to: "/platform/login" })
    }
  },
})

function PlatformAuditLogsPage() {
  const [tenantId, setTenantId] = useState("")
  const [action, setAction] = useState("")
  const deferredTenantId = useDeferredValue(tenantId)

  const logsQuery = useQuery({
    queryKey: ["platformAdmin", "auditLogs", deferredTenantId, action],
    queryFn: () => listPlatformAuditLogs({ tenant_id: deferredTenantId || undefined, action: action || undefined }),
  })

  return (
    <PlatformShell
      title="Audit log"
      description="Ostatnie działania operatorów na tenantach i pending registrations."
    >
      <Stack spacing={5}>
        <Stack direction={{ base: "column", md: "row" }} spacing={4}>
          <Input
            placeholder="Filter by tenant id"
            value={tenantId}
            onChange={(event) => setTenantId(event.target.value)}
          />
          <Select value={action} onChange={(event) => setAction(event.target.value)}>
            <option value="">All actions</option>
            <option value="suspend_tenant">suspend_tenant</option>
            <option value="activate_tenant">activate_tenant</option>
            <option value="resend_pending_registration">resend_pending_registration</option>
            <option value="delete_pending_registration">delete_pending_registration</option>
          </Select>
        </Stack>

        {logsQuery.isLoading ? (
          <Stack spacing={3}>
            <Skeleton h="48px" />
            <Skeleton h="48px" />
            <Skeleton h="48px" />
          </Stack>
        ) : null}

        {logsQuery.isError ? (
          <Alert status="error" borderRadius="lg">
            <AlertIcon />
            <AlertDescription>Failed to load audit logs.</AlertDescription>
          </Alert>
        ) : null}

        {logsQuery.data ? (
          <Box overflowX="auto">
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Action</Th>
                  <Th>Admin</Th>
                  <Th>Target type</Th>
                  <Th>Tenant</Th>
                  <Th>Metadata</Th>
                  <Th>IP</Th>
                  <Th>Created</Th>
                </Tr>
              </Thead>
              <Tbody>
                {logsQuery.data.data.map((entry) => (
                  <Tr key={entry.id}>
                    <Td>{entry.action}</Td>
                    <Td>{entry.admin_email}</Td>
                    <Td>{entry.target_type}</Td>
                    <Td>{entry.tenant_id || "n/a"}</Td>
                    <Td>{entry.metadata_json || "n/a"}</Td>
                    <Td>{entry.ip_address || "n/a"}</Td>
                    <Td>{new Date(entry.created_at).toLocaleString()}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Text mt={4} fontSize="sm" color="gray.500">
              Total: {logsQuery.data.count}
            </Text>
          </Box>
        ) : null}
      </Stack>
    </PlatformShell>
  )
}
